<template>
	<div class="sitemanagement">
		<Nav ref="Nav" />
		<div class="writing_right">
			<div class="TitleList">
				<div class="TitleList_padding">
					<div class="TitleList_top">
						<div class="TitleList_top_title"><span></span>站点管理</div>
						<div class="TitleList_top_btn">
							<button class="btn" @click="handleAddSite">添加站点</button>
						</div>
					</div>
				</div>
				<div class="myarticles" v-loading="loading" element-loading-spinner="el-icon-loading"
					element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 1)">
					<div class="myarticles_content creation">
						<div class="myarticles_content_title">
							<div class="content_title_list">序号</div>
							<div class="content_title_list">站点名称</div>
							<div class="content_title_list">通信状态</div>
							<div class="content_title_list">接口版本</div>
							<div class="content_title_list">网址</div>
							<div class="content_title_list">操作</div>
						</div>
						<div class="myarticles_content_tab">
							<div class="content_tab_list" :class="{ on: info.checked }"
								v-for="(info, index) in infos.data" :key="index">
								<div class="tab_list_li">{{ info.id }}</div>
								<div class="tab_list_li images">
									<div class="testClik">
										<a @click="openSetUp(info)" href="javascript:;">{{ info.name }}</a>
										<a :href="'#/writing/siteManagement/InterfaceTest?id=' + info.id"
											target="_blank" class="hovetest">测试发布</a>
									</div>
								</div>
								<div class="tab_list_li">
									<div class="list_li_state" v-if="info.isActive == 0">
										<span></span>等待请求...
									</div>
									<div class="list_li_state" v-if="info.isActive == 1">
										<span></span>通信正常
									</div>
									<div class="list_li_state on" v-if="info.isActive == -1">
										<span></span>通信异常
									</div>
								</div>
								<div class="tab_list_li">
									<!-- 最新的 -->
									<div class="list_li_state not_update" v-if="info.version_status == 'last'">
										<span></span>
										<p>{{ info.version }}</p>
										<a>最新版</a>
									</div>
									<!-- 用户设置了禁止升级 -->
									<div class="list_li_state need_update"
										v-else-if="info.version_status == 'no_upgrade'">
										<span></span>
										<p title="在接口文件里设置了version为[no_upgrade]禁止在线升级">
											禁止升级
										</p>
									</div>
									<!-- 原始接口获取版本的接口请求返回错误 -->
									<div class="list_li_state need_update" v-else-if="info.version_status == 'error'">
										<span></span>
										<p>{{ info.version }}</p>
										<a>接口版本获取错误，需要检查</a>
									</div>
									<!-- 旧版本需要升级 -->
									<div class="list_li_state need_update" v-else-if="info.version_status == 'old'">
										<span></span>
										<p>{{ info.version }}</p>
										<a v-show="!updating" @click="update_plus(info.id)">升级</a>
										<p v-show="updating">升级中...</p>
									</div>
									<!-- 原始版本，不支持在线升级 -->
									<div class="list_li_state need_update"
										v-else-if="info.version_status == 'original'">
										<span></span>
										<p>1.0发布接口需要升级到2.0</p>
										<a href="https://www.ai-dog.net/news/notify/559.html" target="_blank">升级指导</a>
									</div>
									<!-- 自定义站点接口不支持升级 -->
									<div class="list_li_state" v-else-if="info.version_status == 'diy_site'">
										<span></span>
										<p>自定义站点</p>
										<br />
									</div>
									<!-- 检测状态 -->
									<div class="list_li_state" v-else>
										<span></span>
										<p>版本检测中</p>
									</div>
								</div>
								<div class="tab_list_li">{{ info.website }}</div>
								<div class="tab_list_li operate">
									<div class="list_li_btn" @click="openSetUp(info)">
										<img src="@a/img/sv86.svg" />设置
									</div>
									<div class="list_li_btn" @click="deleteInfo(index)">
										<img src="@a/img/sv6.svg" />删除
									</div>
									<div class="list_li_btn" @click="openNewWindow(info.id)">
										<img src="@a/img/sv11.svg" />日志
									</div>
								</div>
							</div>

							<div class="not_data not_data2" v-show="infos.data.length === 0">
								<div class="not_data_icon">
									<img src="@a/img/bg26.jpg" />
								</div>
								<div class="not_data_title">暂无站点</div>
							</div>
						</div>
					</div>
					<div class="page">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="infos.current_page" :page-sizes="per_pages" :page-size="infos.per_page"
							layout="total, sizes, prev, pager, next, jumper" :total="infos.total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>

		<!-- 设置弹窗2 -->
		<div class="Preview Edit zindex10" v-show="showSetUp2">
			<div class="Preview_content">
				<div class="Preview_content_title">
					<div class="content_title_left"><span></span>{{siteWebmaster.name}}推送设置</div>
					<div class="content_title_right" @click="showSetUp2 = false">
						<i class="el-icon-close"></i>
					</div>
				</div>
				<div class="Edit_content ovauto">
					<div class="Edit_content_list">
						<div class="content_list_dd">
							token
						</div>
						<div class="content_list_dt">
							<el-input placeholder=" " v-model="siteWebmaster.token" clearable>
							</el-input>
						</div>
					</div>
					<div class="Edit_content_list paddleft">
						<div class="content_list_dd">
							开启自动推送
						</div>
						<div class="content_list_dt">
							<div class="radio">
								<el-radio v-model="siteWebmaster.status" :label="1">是</el-radio>
								<el-radio v-model="siteWebmaster.status" :label="0">否</el-radio><span>开启自动推送以后，系统每天凌晨会推送昨天发布的所有文章</span>
							</div>
						</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">
							测试提交
						</div>
						<div class="content_list_dt">
							<el-input type="textarea" :rows="4" placeholder="请输入要提交的测试网址,一行一个" v-model="siteWebmaster.urls" clearable>
							</el-input>
							<button class="save" type="button" @click="testSiteWebmaster">提交测试</button>（测试返回结果请参考下面的：功能说明文档 ）
						</div>
					</div>					
					<div class="Edit_content_list describe">
						<div v-if="siteWebmaster.name=='百度'">
							<p>功能说明指南：<a href="https://www.ai-dog.net/help/ruanwen/32.html" target="_blank">《百度站长提交说明文档》</a></p>
						</div>
						<div v-if="siteWebmaster.name=='必应'">
							<p>功能说明指南：<a href="https://www.ai-dog.net/help/ruanwen/33.html" target="_blank">《必应站长提交说明文档》</a></p>
						</div>
					</div>
				</div>
				<div class="Edit_btn">
					<button class="back" @click="showSetUp2 = false">返回</button>
					<button class="save" @click="saveSiteWebmaster">提交</button>
				</div>
			</div>
		</div>

		<!-- 设置弹窗 -->
		<div class="Preview" v-show="showSetUp">
			<div class="Preview_content">
				<div class="Preview_content_title">
					<div class="content_title_left"><span></span>站点信息</div>
					<div class="content_title_right" @click="closeSetUp">
						<i class="el-icon-close"></i>
					</div>
				</div>
				<div class="SetUp">
					<div class="SetUp_top">
						<div class="SetUp_top_left">
							<img :src="siteInfo?.site?.cms_logo" />
						</div>
						<div class="SetUp_top_right">
							<div class="top_right_dd">
								{{ siteInfo?.site?.name }}
								<span @click="update(siteInfo?.site?.id)">
									<img src="@a/img/sv5.svg" />编辑
								</span>
							</div>
							<div class="top_right_dt">
								<a :href="'http://'+siteInfo?.site?.website" target="_blank">{{siteInfo?.site?.website}}</a>
							</div>
						</div>
					</div>
					<div class="SetUp_cotnent">
						<router-link :to="'/writing/releaselog?site_id=' + siteInfo?.site?.id + '&time=1'" target="_blank" class="SetUp_cotnent_list">
							<div class="cotnent_list_dd">
								{{ siteInfo?.todayArticleCount || 0 }}
							</div>
							<div class="cotnent_list_dt">今日发布</div>
						</router-link>
						<router-link :to="'/writing/releaselog?site_id=' + siteInfo?.site?.id + '&time=-1'" target="_blank" class="SetUp_cotnent_list">
							<div class="cotnent_list_dd">
								{{ siteInfo?.yesterdayArticleCount || 0 }}
							</div>
							<div class="cotnent_list_dt">昨日发布</div>
						</router-link>
						<router-link :to="'/writing/releaselog?site_id=' + siteInfo?.site?.id + '&time=current_month'" target="_blank" class="SetUp_cotnent_list">
							<div class="cotnent_list_dd">{{ siteInfo?.currentMonthArticleCount || 0 }}</div>
							<div class="cotnent_list_dt">本月发布</div>
						</router-link>
						<router-link :to="'/writing/releaselog?site_id=' + siteInfo?.site?.id + '&time=last_month'" target="_blank" class="SetUp_cotnent_list">
							<div class="cotnent_list_dd">{{ siteInfo?.lastMonthArticleCount || 0 }}</div>
							<div class="cotnent_list_dt">上个月发布</div>
						</router-link>
						<router-link :to="'/writing/releaselog?site_id=' + siteInfo?.site?.id + ''" target="_blank" class="SetUp_cotnent_list">
							<div class="cotnent_list_dd">
								{{ siteInfo?.allArticleCount || 0 }}
							</div>
							<div class="cotnent_list_dt">累计发布</div>
						</router-link>
						<div class="SetUp_cotnent_list" @click="showLinkList(siteInfo.site)">
							<div class="cotnent_list_dd">
								{{ siteInfo?.linkCount || 0 }}
							</div>
							<div class="cotnent_list_dt">锚链接</div>
						</div>
						<router-link :to="'/writing/webMasterPushLog?site_id=' + siteInfo?.site?.id + '&webmaster_id='+siteInfo?.site?.webmaster_baidu_id" target="_blank" class="SetUp_cotnent_list">
							<div class="cotnent_list_dd">
								{{ siteInfo?.baiduPushCount || 0 }}
							</div>
							<div class="cotnent_list_dt">百度站长提交统计</div>
						</router-link>
						<router-link :to="'/writing/webMasterPushLog?site_id=' + siteInfo?.site?.id + '&webmaster_id='+siteInfo?.site?.webmaster_bing_id" target="_blank" class="SetUp_cotnent_list">
							<div class="cotnent_list_dd">
								{{ siteInfo?.bingPushCount || 0 }}
							</div>
							<div class="cotnent_list_dt">Bing站长提交统计</div>
						</router-link>
					</div>
					<div class="SetUp_bottom">
						<div class="SetUp_bottom_list" @click="showLinkList(siteInfo?.site)">
							<div class="bottom_list_icon"><img src="@a/img/sv112.svg" /></div>
							<div class="bottom_list_title">锚链接设置</div>
						</div>
						<div class="SetUp_bottom_list" @click="showKeywordsLibrary(siteInfo?.site)">
							<div class="bottom_list_icon"><img src="@a/img/sv113.svg" /></div>
							<div class="bottom_list_title">关键词过滤设置</div>
						</div>
						<router-link :to="'/writing/releaselog?site_id=' + siteInfo?.site?.id + ''" target="_blank" class="SetUp_bottom_list">
							<div class="bottom_list_icon"><img src="@a/img/sv114.svg" /></div>
							<div class="bottom_list_title">发布日志</div>
						</router-link>
						<router-link :to="'/writing/planTorelease?site_id=' + siteInfo?.site?.id + ''" target="_blank" class="SetUp_bottom_list">
							<div class="bottom_list_icon"><img src="@a/img/sv115.svg" /></div>
							<div class="bottom_list_title">发布计划</div>
						</router-link>
						<div class="SetUp_bottom_list" @click="setSiteMaster(siteInfo?.site,'百度',siteInfo?.site?.webmaster_baidu_id)">
							<div class="bottom_list_icon"><img src="@a/img/sv116.svg" /></div>
							<div class="bottom_list_title">百度站长提交设置</div>
						</div>
						<div class="SetUp_bottom_list" @click="setSiteMaster(siteInfo?.site,'必应',siteInfo?.site?.webmaster_bing_id)">
							<div class="bottom_list_icon"><img src="@a/img/sv117.svg" /></div>
							<div class="bottom_list_title">Bing站长提交设置</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 关键词锚文本 -->
		<div class="Preview" v-show="showLog">
			<div class="Preview_content">
				<div class="Preview_content_title">
					<div class="content_title_left"><span></span>关键词锚文本</div>
					<div class="content_title_right" @click="showLog = false">
						<i class="el-icon-close"></i>
					</div>
				</div>
				<div class="KeyWords">
					<div class="KeyWordsTop">
						<div class="KeyWordsTop_list">序号</div>
						<div class="KeyWordsTop_list">关键词</div>
						<div class="KeyWordsTop_list">链接</div>
						<div class="KeyWordsTop_list">操作</div>
					</div>
					<div class="KeyWordsContent ovauto">
						<div class="KeyWordsContent_list" v-for="(item, index) in linkList" :key="index">
							<div class="KeyWordsContent_list_li">{{ index + 1 }}</div>
							<div class="KeyWordsContent_list_li" :class="{ active: item.isActive }">
								<b :class="{ active: item.isActive }">{{ item.name }}</b>
								<input type="text" v-model="item.name" />
							</div>
							<div class="KeyWordsContent_list_li" :class="{ active: item.isActive }">
								<a :href="item.url" target="_blank" :class="{ active: item.isActive }">{{ item.url
									}}</a>
								<input type="text" v-model="item.url" />
							</div>
							<div class="KeyWordsContent_list_li" :class="{ active: item.isActive }">
								<div class="list_li_btn" @click="toggleActive2(index)">
									<img src="@a/img/sv5.svg" />
									<span v-if="!item.isActive">编辑</span>
									<span v-if="item.isActive">保存</span>
								</div>
								<div class="list_li_btn" @click="deleteInfo2(index)">
									<img src="@a/img/sv6.svg" />删除
								</div>
							</div>
						</div>
					</div>
					<div class="KeyWordsBottom">
						<img src="@a/img/sv47.svg" />在发布文章内容中如果出现以下关键词为自动加上对应的超链接，<br />加上超链接的关键词更有利于搜索引擎优化
					</div>
					<div class="KeyWordsBtn notBlue" @click="addLink()">
						<span>添加锚文本</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 关键词库 -->
		<div class="Preview" v-show="keywords_library_show">
			<div class="Preview_content">
				<div class="Preview_content_title">
					<div class="content_title_left"><span></span>关键词库过滤</div>
					<div class="content_title_right" @click="keywords_library_show = false">
						<i class="el-icon-close"></i>
					</div>
				</div>
				<div class="KeyWords">
					<el-input type="textarea" :rows="20" placeholder="关键词1,关键词2" v-model="keywords_library"></el-input>
				</div>
				<div class="content_list_hint">
					<img
						src="@a/img/sv47.svg" />每个关键词用,号隔开。<br />如果添加关键词过滤后，在发布文章后会默认匹配当前关键词库里对应的关键词，匹配的数量为3-6个之间。如果留空的话会默认调用AI生成的关键词发布到站点里的keywords和tags里。
				</div>
				<div class="Edit_btn">
					<button class="save" @click="setKeywordsLibrary()">保存</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Nav from "@c/common/nav/nav";
import { Message, MessageBox } from "element-ui";
import axios from "axios";

export default {
	name: "siteManagement",
	data() {
		return {
			plan1: '',
			plan2: '',
			showSetUp2: false,
			infos: {
				data: [],
				per_page: 20,
				current_page: 1,
				last_page: 1,
				total: 0,
			},
			per_pages: [20, 50, 100, 200],
			showLog: false,
			showSetUp: false,
			currentInfo: null, // 新增：存储当前选中的站点信息
			site_id: 0,
			keywords_library: "",
			keywords_library_show: false,
			linkList: [],
			currentSite: [],
			loading: true,
			updating: false,
			siteInfo:[],//站点详情相关信息
			siteWebmasterTestPass:false,//站长推送测试接口是否通过
			siteWebmaster:{
				name:'',
				site_id:'',
				token:'',
				status:1,//开启状态
			},//站长推送设置相关
		};
	},
	components: {
		Nav,
	},
	methods: {
		//站长推送设置
		setSiteMaster(site,webmastername,webmasterid){
			this.siteWebmaster={}
			this.siteWebmasterTestPass=false  //打开站点配置设置不通过，只通点击测试通过才允许通过
			this.siteWebmaster.status=1
			this.siteWebmaster.name=webmastername
			this.siteWebmaster.id=webmasterid
			this.siteWebmaster.site_id=site.id
			this.showSetUp2=true
			this.axios.get("/api/Site/getSiteWebmaster", {
				params: {
					site_id: site.id,
					name:webmastername,
				},
			}).then((res) => {
				if (res.code) {
					let data=res.result
					if(data.id){
						this.siteWebmaster=data
					}
				}
			});	

		},
		//保存站长推送相关配置
		saveSiteWebmaster(){
			let data=this.siteWebmaster
			if(!this.siteWebmasterTestPass){
				this.$message.error("请先点击【提交测试】并通过后再保存！")
				return
			}
			this.axios.post("/api/Site/setSiteWebmaster",data).then((res) => {
				if (res.code) {
					this.$message.success("设置成功");
					this.showSetUp2=false
				}else{
					this.$message.error(res.msg);
				}
			});	
		},
		//测试站长推送相关配置
		testSiteWebmaster(){
			let data=this.siteWebmaster
			this.axios.post("/api/Site/testWebmasterPush",data).then((res) => {
				if (res.code) {
					this.siteWebmasterTestPass=true
					this.$message.success({message: '设置成功，返回结果' + res.msg,duration: 5000});
				}
			});	
		},		
		// 打开设置弹窗并保存当前站点信息
		openSetUp(info) {
			this.axios
				.get("/api/Site/getSite2", {
					params: {
						id: info.id,
					},
				})
				.then((res) => {
					if (res.code) {
						this.siteInfo=res.result
						console.log(res.result)
						
					}
				});
			
			
			
			
			
			
			console.log("Opening setup for site:", info);
			this.currentInfo = info; // 保存当前站点信息
			this.showSetUp = true; // 显示弹窗
		},
		// 关闭设置弹窗
		closeSetUp() {
			this.showSetUp = false;
			this.currentInfo = null; // 清空当前站点信息
		},
		// 路由跳转到参数设置页面
		update(id) {
			console.log("Update triggered with ID:", id);

			// 参数验证
			if (!id || isNaN(id)) {
				this.$message.error("无效的站点ID，请重试！");
				console.error("Invalid ID:", id);
				return;
			}

			try {
				// 关闭弹窗
				this.showSetUp = false;
				this.currentInfo = null;
				console.log("showSetUp set to false");

				// 执行路由跳转
				const settingsPath = "/writing/siteManagement/parameterSettings";
				this.$router
					.push({
						path: settingsPath,
						query: { sid: id },
					})
					.then(() => {
						console.log("Navigation successful");
					})
					.catch((err) => {
						if (err.name !== "NavigationDuplicated") {
							this.$message.error("路由跳转失败，请稍后重试！");
							console.error("Router error:", err);
						} else {
							console.log("Navigation duplicated, ignoring");
						}
					});
			} catch (error) {
				this.$message.error("操作失败，请联系管理员！");
				console.error("Update error:", error);
			}
		},
		// 会员站点状态
		async handleAddSite() {
			try {
				const res = await this.axios.get("api/Seo/memberSiteStatus");
				if (res.code === 1) {
					this.$router.push("/writing/siteManagement/autoEprogram");
				} else {
					this.$refs.Nav.childMethod();
				}
			} catch (error) {
				console.error("请求站点状态时出错:", error);
			}
		},
		// 在线升级
		update_plus(site_id) {
			this.updating = true;
			this.axios
				.get("/api/Site/updatePlus", {
					params: {
						site_id: site_id,
					},
				})
				.then((res) => {
					if (res.code) {
						Message.success("升级成功！");
						this.updating = false;
						this.getList();
					}
				});
		},
		// 分类设置保存、编辑
		toggleActive2(index) {
			let thisData = this.linkList[index];
			if (thisData.isActive) {
				this.axios
					.post("/api/SiteLink/add", {
						id: thisData.id,
						name: thisData.name,
						site_id: this.currentSite.id,
						url: thisData.url,
					})
					.then((res) => {
						if (res.code == 1) {
							Message.success("保存成功！");
							this.showLinkList(this.currentSite);
						}
					});
			}
			this.linkList[index].isActive = !thisData.isActive;
		},
		// 打开站点锚链接列表
		showLinkList(site) {
			this.showLog = true;
			this.currentSite = site;
			this.axios
				.get("/api/SiteLink/list", {
					params: {
						site_id: site.id,
					},
				})
				.then((res) => {
					if (res.result) {
						res.result.forEach((item) => {
							item.isActive = false;
						});
						this.linkList = res.result;
					}
				});
		},
		// 新增加链接
		addLink() {
			let url = "";
			if (this.currentSite.is_https) {
				url = "https://" + this.currentSite.website;
			} else {
				url = "http://" + this.currentSite.website;
			}
			this.linkList.push({
				id: 0,
				site_id: this.currentSite.id,
				name: "",
				url: url,
				isActive: true,
			});
		},
		// 关键词库
		showKeywordsLibrary(info) {
			this.site_id = info.id;
			this.keywords_library_show = true;
			this.keywords_library = "";
			this.axios
				.get("/api/Site/showKeywordsLibrary", {
					params: {
						site_id: info.id,
					},
				})
				.then((res) => {
					if (res.result) {
						this.keywords_library = res.result.keywords_library;
					}
				});
		},
		// 保存关键词库
		setKeywordsLibrary() {
			this.axios
				.post("/api/Site/setKeywordsLibrary", {
					site_id: this.site_id,
					keywords_library: this.keywords_library,
				})
				.then((res) => {
					this.keywords_library_show = false;
				});
		},
		// 删除分类链接
		deleteInfo2(index) {
			const item = this.linkList[index];
			MessageBox.confirm(`确定删除${item.name}吗？`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.axios
						.post("/api/SiteLink/delete", {
							id: item.id,
						})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "删除成功!",
								});
								this.showLinkList(this.currentSite);
							}
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		// 分页
		handleSizeChange(val) {
			this.infos.per_page = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.infos.current_page = val;
			this.getList();
		},
		// 新窗口打开
		openNewWindow(id, time = 0) {
			if (time === 1) {
				window.open(
					"#/writing/releaselog?site_id=" + id + "&time=1",
					"_blank",
					"noopener"
				);
			} else if (time === -1) {
				window.open(
					"#/writing/releaselog?site_id=" + id + "&time=-1",
					"_blank",
					"noopener"
				);
			} else {
				window.open(
					"#/writing/releaselog?site_id=" + id,
					"_blank",
					"noopener"
				);
			}
		},
		// 获取站点列表
		getList() {
			this.loading = true;
			this.axios
				.get("/api/site/list", {
					params: {
						page: this.infos.current_page,
						list_rows: this.infos.per_page,
					},
				})
				.then((res) => {
					this.loading = false;
					this.infos = res.result;
					for (let i in this.infos.data) {
						let url = this.infos.data[i]["url"];
						this.axios
							.post("/api/site/urlIsNormal", {
								url: url,
							})
							.then((res) => {
								if (res.code === 1) {
									this.infos.data[i]["isActive"] = res.result;
								}
							});
					}
					this.checkVersion(0);
				});
		},
		// 检测版本
		checkVersion(i) {
			if (i >= this.infos.data.length) return;
			let id = this.infos.data[i]["id"];
			if (id) {
				this.axios
					.post("/api/site/checkVersion", {
						id: id,
					})
					.then((res) => {
						if (res.code === 1) {
							this.$set(
								this.infos.data[i],
								"version_status",
								res.result.version_status
							);
							this.$set(this.infos.data[i], "version", res.result.version);
						}
						this.checkVersion(i + 1);
					});
			}
		},
		// 删除站点
		deleteInfo(index) {
			const item = this.infos.data[index];
			MessageBox.confirm(`确定删除${item.name}吗？`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.axios
						.post("/api/site/delete", {
							id: item.id,
						})
						.then((res) => {
							if (res.code === 1) {
								this.$message({
									type: "success",
									message: "删除成功!",
								});
								this.getList();
							}
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
	},
	created() {
		this.getList();
	},
};
</script>

<style>
@import "siteManagement.css";
</style>